import React from 'react';
import BaseModal from '@src/components/modal';
import CreateWcpComp from './create-wcp';
import store from './store'

const CreateConverModal = {
  self: null,
  show(data = {}) {
    // 20250208 改为跳首页
    this.self = BaseModal.show({
      wrapClassName: 'nw-base-modal nw-base-modal-p-0 create-wcp-modal',
      borderRadius: 24,
      getContainer: document.getElementById('nworld-app-wcp-modal-container'),
      // closable: false,
      content: (
        <CreateWcpComp
          {...data}
          onClose={() => {
            this.close();
          }}
        ></CreateWcpComp>
      ),
      afterClose: () => {
        this.close();
        store.resetForm()
      },
    });
    
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
      
    }
  },
};

export default CreateConverModal;
